import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { Period } from '../../../components/modals/LogsModal/utils'
import { fetchProductLogs } from './fetchProductLogs'
import { getUrlWithVersion } from '../../../api/api'

export const prepareProductLogs = createAsyncThunk<
    void,
    { datesToSend: Period; guid: string },
    ThunkConfig<string>
>('logsSlice/prepareProductLogs', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { datesToSend, guid } = args
    try {
        const res = await api.post(
            getUrlWithVersion(`/logs/${guid}/request`),
            datesToSend
        )

        if (res.status === 204) {
            throwSuccessMessage('No files found')
            return
        }

        if (res.status === 200) {
            dispatch(fetchProductLogs())
        }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to prepare product logs files')
    }
})
